import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { SubFsm } from 'little-fsm';

import PaymentExistingErrorPage from '../pages/paymentselection/PaymentAlreadyExistsErrorPage';
import { PaymentCompletedFsmScheme } from '../states/payment-complete/PaymentCompleteFsmScheme';
import { getIntlStringValue } from '../helpers/StringHelpers';
import { ActionItemDescriptor } from '../components/MaterialDesignComponents';
import { ApiService } from '../ApiService';

export function buildPaymentCompletedPresenter(
    appContext: AppContext,
    apiService: ApiService,
    subFsm: SubFsm<PaymentCompletedFsmScheme>): {
        render: () => m.Vnode
    } {
    return {
        render() {
            let context = subFsm.getCurrentContext();
            let substate = subFsm.getCurrentSubState();   
            return m(PaymentExistingErrorPage, {
                appContext: appContext, 
                collapsedActionItems: buildMenuItems(appContext, subFsm),
                tentativeBooking: context.tentativeBookingReviewContext.tentativeBooking,
                isBacktracking: substate == 'back_navigation_confirming',
                onClose: () => {
                    subFsm.processEvent('back', {});
                },
                onBacktrack: () => {
                    subFsm.processEvent('back', {});
                },         
                onBacktrackConfirmed: () => {
                    subFsm.processEvent('back_confirmed', {});
                },
                onBacktrackCancelled: () => {
                    subFsm.processEvent('back_cancelled', {});
                },
                onForceBackToHome: () => {
                    subFsm.processEvent('force_back_to_home', {});
                    m.redraw();
                }
            })
        }
    }
}



function buildMenuItems(appContext: AppContext, subFsm: SubFsm<PaymentCompletedFsmScheme>): ActionItemDescriptor[] {
    const messageProvider = appContext.getMessageProvider();

    let menuItems = appContext.getExternalMenuItems().map(it => {
        return {
            "label": getIntlStringValue(it.label, messageProvider.getCurrentLang()),
            onclick: () => {
                window.location.assign(it.href);
            }
        }
    })
    console.info("ext links", menuItems);
    return menuItems;
}